import { Link, Stack, StackTypeMap, Typography } from "@mui/material";
import React, { FC } from "react";
import Image from "./Image";
import { OverridableComponent } from "@mui/material/OverridableComponent";

interface EmployeeContactProps {
  name: string;
  email: string;
  image: string;
  role?: string;
  stackProps?: StackTypeMap<{}, "div">["props"];
}

const EmployeeContact: FC<EmployeeContactProps> = ({
  name,
  role,
  email,
  image,
  stackProps,
}) => (
  <Stack direction="row" {...stackProps}>
    <Image
      alt={`${name} contact photo`}
      name={image}
      style={{ width: "91px", height: "91px", borderRadius: "100%" }}
    />
    <Stack ml={2} justifyContent="center">
      {role && (
        <Typography variant="caption" fontWeight="bold" mb={0.5}>
          {role}
        </Typography>
      )}
      <Typography variant="body2">{name}</Typography>
      <Typography variant="body2" mt={0.5}>
        <Link underline="always" href={`mailto:${email}`}>
          {email}
        </Link>
      </Typography>
    </Stack>
  </Stack>
);

export default EmployeeContact;
